import './SPOnboardingBox.scss';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SPActivityCard from '../ActivityCard/SPActivityCard';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function SPOnboarding() {
  const {onboardingStatus} = useSelector((state: any) => state.sellerProfile);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const completedCount = onboardingStatus?.completed;

  const { t } = useTranslation();

  const activityCardData = [
    {
      id: 1,
      title: 'registerCard',
      name: t('sellerProfile.dashboard.regUsers'),
      description: t('sellerProfile.dashboard.addNewUsersDescription'),
      completed: onboardingStatus?.user,
      link: '/seller-profile/users'
    },
    {
      id: 2,
      title: 'registerCard',
      name: t('sellerProfile.dashboard.submitQuestionnaire'),
      description: t('sellerProfile.dashboard.submitQuestionnaireDescription'),
      completed: onboardingStatus?.questionnaire,
      link: '/seller-profile/questionnaire'
    },
    {
      id: 3,
      title: 'registerCard',
      name: t('sellerProfile.dashboard.setNotifications'),
      description: t('sellerProfile.dashboard.setNotificationsDescription'),
      completed: onboardingStatus?.notification,
      link: '/seller-profile/notifications'
    }
  ];

  useEffect(() => {
    setIsExpanded(onboardingStatus?.completed !== 3);
  }, [onboardingStatus]);

  return (
    <Box className="spOnboarding">
      <Box className="onBoardingHeader"
         role="button"
         tabIndex={0}
         aria-expanded={isExpanded}
         aria-controls="onboarding-content"
         onClick={() => setIsExpanded(!isExpanded)}
         onKeyDown={(e) => {
           if (e.key === 'Enter' || e.key === ' ') {
             e.preventDefault();
             setIsExpanded((s) => !s);
           }
         }} 
      >
        <h2>{t('sellerProfile.dashboard.onSteps')}</h2>
        {Array(activityCardData.length)
          .fill(1)
          .map((item, i) => {
            return (
              <span
                key={`${item}-${i}`}
                aria-hidden={true}
                className={`stepCircle ${i < completedCount ? '' : 'notCompleted'
                  }`}
              />
            );
          })}
        <span
          className="completedStepCount"
          aria-label={
            completedCount +
            ' out of ' +
            activityCardData.length +
            ' steps are completed'
          }
        >
          {completedCount}/{activityCardData.length}
        </span>
        {isExpanded ? (
          <ExpandLessIcon
            className="expandingIcon"
            onClick={() => setIsExpanded(false)}
          />
        ) : (
          <ExpandMoreIcon
            className="expandingIcon"
            onClick={() => setIsExpanded(true)}
          />
        )}
      </Box>
      {isExpanded && (
        <>
          <p className="onBoardingInfoText">
            {t('sellerProfile.dashboard.completeInstructions')}
          </p>
          <SPActivityCard
            activityCardData={activityCardData}
            className="statusCards"
          />
        </>
      )}
    </Box>
  );
}

export default SPOnboarding;
